import { red, pink, deepPurple, blue, teal, green, blueGrey } from '@mui/material/colors'

export interface FileIconType {
	color: string
	labelColor: string
	glyphColor: string
	mimeType: string
}

export const fileIcon: { [key: string]: FileIconType } = {
	jpeg: {
		color: deepPurple['50'],
		labelColor: deepPurple['A400'],
		glyphColor: deepPurple['A400'],
		mimeType: 'image/jpeg',
	},
	jpg: {
		color: deepPurple['50'],
		labelColor: deepPurple['A400'],
		glyphColor: deepPurple['A400'],
		mimeType: 'image/jpeg',
	},
	png: {
		color: deepPurple['50'],
		labelColor: deepPurple['A400'],
		glyphColor: deepPurple['A400'],
		mimeType: 'image/png',
	},
	bmp: {
		color: deepPurple['50'],
		labelColor: deepPurple['A400'],
		glyphColor: deepPurple['A400'],
		mimeType: 'image/bmp',
	},
	gif: {
		color: deepPurple['50'],
		labelColor: deepPurple['A400'],
		glyphColor: deepPurple['A400'],
		mimeType: 'image/gif',
	},
	mp4: {
		color: teal['50'],
		labelColor: teal['A700'],
		glyphColor: teal['A700'],
		mimeType: 'video/mp4',
	},
	mpeg: {
		color: teal['50'],
		labelColor: teal['A400'],
		glyphColor: teal['A400'],
		mimeType: 'video/mpeg',
	},
	webm: {
		color: teal['50'],
		labelColor: teal['A400'],
		glyphColor: teal['A400'],
		mimeType: 'video/webm',
	},
	mov: {
		color: teal['50'],
		labelColor: teal['A400'],
		glyphColor: teal['A400'],
		mimeType: 'video/quicktime',
	},
	avi: {
		color: teal['50'],
		labelColor: teal['A400'],
		glyphColor: teal['A400'],
		mimeType: 'video/x-msvideo',
	},
	txt: {
		color: blueGrey['50'],
		labelColor: blueGrey['A700'],
		glyphColor: blueGrey['A400'],
		mimeType: 'text/plain',
	},
	csv: {
		color: blueGrey['50'],
		labelColor: blueGrey['A700'],
		glyphColor: blueGrey['A400'],
		mimeType: 'text/csv',
	},
	xls: {
		color: green['800'],
		labelColor: green['800'],
		glyphColor: 'rgba(255,255,255,0.4)',
		mimeType: 'application/vnd.ms-excel',
	},
	xlsx: {
		color: green['800'],
		labelColor: green['800'],
		glyphColor: 'rgba(255,255,255,0.4)',
		mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	},
	doc: {
		color: blue['800'],
		labelColor: blue['800'],
		glyphColor: 'rgba(255,255,255,0.4)',
		mimeType: 'application/msword',
	},
	docx: {
		color: blue['800'],
		labelColor: blue['800'],
		glyphColor: 'rgba(255,255,255,0.4)',
		mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	},
	ppt: {
		color: red['800'],
		labelColor: red['800'],
		glyphColor: 'rgba(255,255,255,0.4)',
		mimeType: 'application/vnd.ms-powerpoint',
	},
	pptx: {
		color: red['700'],
		labelColor: red['700'],
		glyphColor: 'rgba(255,255,255,0.4)',
		mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	},
	pdf: {
		color: pink['50'],
		labelColor: pink['A700'],
		glyphColor: pink['A400'],
		mimeType: 'application/pdf',
	},
}
